import { generatePath } from "react-router-dom";

import { APP_ROUTES } from "../../../../../../../../system/constants/constantsUrl";

export const getGamerProfilePath = (id, project_id) =>
  generatePath(APP_ROUTES.dashboard.gamer_profile, {
    projectId: project_id,
    gamerId: id,
  });
